<template>
    <div class="content-card mb-4">
        <div class="content-card-title">ยอดแทงวันนี้</div>
        <div class="content-card-body">
            <h2 class="mb-0">฿ {{ balanceDay }}</h2>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    balanceDay: {
      type: String,
      default: '0.00'
    }
  },
  data () {
    return {
      link: ''

    }
  },
  created () {

  },
  methods: {

  },
  computed: {

  },
  watch: {

  },
  mounted () {
    console.log('Component mounted!')
  }
}
</script>
